<mat-card>
    <mat-card-header>
        <mat-card-title>Lavorazione selezionata: {{nomelavorazione}} ({{nomestatolavorazione}})</mat-card-title>
    </mat-card-header>
    <mat-card-content class="content">
      <form>
        <mat-form-field style="padding-right:10px">
           <mat-label class="text-sm">Catalogo</mat-label>
           <mat-select [(ngModel)]="selectedValueCatalogo" name="gruppo" (selectionChange)="manageChangeCatalogo()" class="text-sm">
             <mat-option *ngFor="let catalogo of cataloghi" [value]="catalogo.Nome">
               {{catalogo.Nome}}
             </mat-option>
           </mat-select>
         </mat-form-field>

         <mat-form-field style="padding-right:10px">
            <mat-label class="text-sm">Codice articolo</mat-label>
            <input matInput [(ngModel)]="filtroCodicearticolo" name="filtroCodicearticolo" (keyup)="onFiltroCodicearticoloKeyup($event)" class="text-sm">
         </mat-form-field>

         <mat-form-field style="padding-right:10px">
            <mat-label class="text-sm">Descrizione</mat-label>
            <input matInput [(ngModel)]="filtroDescrizione" name="filtroDescrizione" (keyup)="onFiltroDescrizioneKeyup($event)" class="text-sm">
         </mat-form-field>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
<!--
          <ng-container matColumnDef="sel">
              <th mat-header-cell *matHeaderCellDef>Seleziona</th>
              <td mat-cell *matCellDef="let articolo">
                  <mat-checkbox (change)="selezionato(articolo)"></mat-checkbox>
            </td>
          </ng-container>
-->
          <ng-container matColumnDef="Id">
              <th [style.display]="getConfigurazione().Id" mat-header-cell *matHeaderCellDef>Id
                <img src="./assets/images/sort.png" (click)="manageClick('Id')"/>
              </th>
              <td [style.display]="getConfigurazione().Id" mat-cell *matCellDef="let articolo"> {{articolo.Id}} </td>
          </ng-container>

          <ng-container matColumnDef="Codicearticolo">
              <th [style.display]="getConfigurazione().Codicearticolo" mat-header-cell *matHeaderCellDef>Codice articolo
                <img src="./assets/images/sort.png" (click)="manageClick('Codicearticolo')"/>
              </th>
              <td [style.display]="getConfigurazione().Codicearticolo" mat-cell *matCellDef="let articolo"> {{articolo.Codicearticolo}} </td>
          </ng-container>

          <ng-container matColumnDef="Descrizione">
              <th [style.display]="getConfigurazione().Descrizione" mat-header-cell *matHeaderCellDef>Descrizione
                <img src="./assets/images/sort.png" (click)="manageClick('Descrizione')"/>
              </th>
              <td [style.display]="getConfigurazione().Descrizione" mat-cell *matCellDef="let articolo"> {{articolo.Descrizione}} </td>
          </ng-container>

          <ng-container matColumnDef="Categoria">
              <th [style.display]="getConfigurazione().Categoria" mat-header-cell *matHeaderCellDef>Categoria
                <img src="./assets/images/sort.png" (click)="manageClick('Categoria')"/>
              </th>
              <td [style.display]="getConfigurazione().Categoria" mat-cell *matCellDef="let articolo"> {{articolo.Categoria}} </td>
          </ng-container>

          <ng-container matColumnDef="Costo">
              <th [style.display]="getConfigurazione().Costo" mat-header-cell *matHeaderCellDef>Costo
                <img src="./assets/images/sort.png" (click)="manageClick('Costo')"/>
              </th>
              <td [style.display]="getConfigurazione().Costo" mat-cell *matCellDef="let articolo"> {{articolo.Costo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Iva">
              <th [style.display]="getConfigurazione().Iva" mat-header-cell *matHeaderCellDef>IVA %
                <img src="./assets/images/sort.png" (click)="manageClick('Iva')"/>
              </th>
              <td [style.display]="getConfigurazione().Iva" mat-cell *matCellDef="let articolo"> {{articolo.Iva}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzo">
              <th [style.display]="getConfigurazione().Prezzo" mat-header-cell *matHeaderCellDef>Prezzo
                <img src="./assets/images/sort.png" (click)="manageClick('Prezzo')"/>
              </th>
              <td [style.display]="getConfigurazione().Prezzo" mat-cell *matCellDef="let articolo"> {{articolo.Prezzo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Giacenza">
              <th [style.display]="getConfigurazione().Giacenza" mat-header-cell *matHeaderCellDef>Giacenza
                <img src="./assets/images/sort.png" (click)="manageClick('Giacenza')"/>
              </th>
              <td [style.display]="getConfigurazione().Giacenza" mat-cell *matCellDef="let articolo"> {{articolo.Giacenza | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Unitamisura">
              <th [style.display]="getConfigurazione().Unitamisura" mat-header-cell *matHeaderCellDef>Unita di misura
                <img src="./assets/images/sort.png" (click)="manageClick('Unitamisura')"/>
              </th>
              <td [style.display]="getConfigurazione().Unitamisura" mat-cell *matCellDef="let articolo"> {{articolo.Unitamisura}} </td>
          </ng-container>

          <ng-container matColumnDef="add">
              <th mat-header-cell *matHeaderCellDef> Aggiungi </th>
              <td mat-cell *matCellDef="let articolo">
                <ng-container *ngIf="!isReadonly()">
                  <mat-icon color="primary" (click)="addArticolo(articolo)">add_circle</mat-icon>
                </ng-container>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

  <table mat-table [dataSource]="dataSource2" class="mat-elevation-z8">

          <ng-container matColumnDef="Id">
            <th style="display:none" mat-header-cell *matHeaderCellDef>Id</th>
            <td style="display:none" mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Id}} </td>
          </ng-container>

          <ng-container matColumnDef="Codicearticolo">
            <th mat-header-cell *matHeaderCellDef>Codice articolo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Codicearticolo}} </td>
          </ng-container>

          <ng-container matColumnDef="Descrizione">
            <th mat-header-cell *matHeaderCellDef>Descrizione</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Descrizione}} </td>
          </ng-container>

          <ng-container matColumnDef="Costo">
            <th mat-header-cell *matHeaderCellDef>Costo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Costo}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzo">
            <th mat-header-cell *matHeaderCellDef>Prezzo</th>
            <td mat-cell *matCellDef="let lavorazionearticolo">
              <ng-container *ngIf="!isReadonly()">
                <input matInput value="{{lavorazionearticolo.Prezzo}}" (keyup)="onPrezzoKeyup(lavorazionearticolo, $event)">
              </ng-container>
              <ng-container *ngIf="isReadonly()">
                {{lavorazionearticolo.Prezzo}}
              </ng-container>
          </td>
          </ng-container>

          <ng-container matColumnDef="Quantita">
            <th mat-header-cell *matHeaderCellDef>Quantità</th>
            <td mat-cell *matCellDef="let lavorazionearticolo">
              <ng-container *ngIf="!isReadonly()">
                <input matInput value="{{lavorazionearticolo.Quantita}}" (keyup)="onQuantitaKeyup(lavorazionearticolo,$event)">
              </ng-container>
              <ng-container *ngIf="isReadonly()">
                {{lavorazionearticolo.Quantita}}
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="Unitamisura">
            <th mat-header-cell *matHeaderCellDef>Unità di misura</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Articolo.Unitamisura}} </td>
          </ng-container>

          <ng-container matColumnDef="Iva">
            <th mat-header-cell *matHeaderCellDef>IVA</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Iva}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzototale">
            <th mat-header-cell *matHeaderCellDef>Prezzo totale</th>
            <td mat-cell *matCellDef="let lavorazionearticolo"> {{lavorazionearticolo.Prezzototale}} </td>
          </ng-container>

          <ng-container matColumnDef="remove">
              <th mat-header-cell *matHeaderCellDef> Togli </th>
              <td mat-cell *matCellDef="let lavorazionearticolo">
                <ng-container *ngIf="!isReadonly()">
                  <mat-icon color="primary" (click)="removeArticolo(lavorazionearticolo)">remove_circle</mat-icon>
                </ng-container>
              </td>
          </ng-container>

          <ng-container matColumnDef="save">
              <th mat-header-cell *matHeaderCellDef> Salva </th>
              <td mat-cell *matCellDef="let lavorazionearticolo">
                <button [disabled]="isReadonly() || isModificato(lavorazionearticolo)==='NO'" (click)="saveArticolo(lavorazionearticolo)">
                  <mat-icon color="primary">save</mat-icon>
                </button>
              </td>
          </ng-container>

          <ng-container matColumnDef="detail">
              <th mat-header-cell *matHeaderCellDef> Dettaglio </th>
              <td mat-cell *matCellDef="let lavorazionearticolo">
                <button (click)="detailArticolo(lavorazionearticolo)">
                  <mat-icon color="primary">description</mat-icon>
                </button>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
        </table>


      </form>
    </mat-card-content>
    <!--
    <mat-card-actions>
      <button mat-raised-button  color="primary" (click)="save()">Salva</button>
      <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      <button mat-raised-button  color="primary" (click)="back()">Indietro</button>
    </mat-card-actions>
    -->

</mat-card>
